'use client';

import { Box } from '@chakra-ui/react';
import type { MouseEventHandler, PropsWithChildren } from 'react';
import { trackCustomEvent } from '@ifixit/analytics';
import { PrerenderedHTML } from '@ifixit/prerendered-html';

export interface RibbonBannerData {
   title: string;
   displayText: string;
}

export interface RibbonBannerProps {
   ribbon?: RibbonBannerData;
}

export function RibbonBanner({ ribbon }: PropsWithChildren<RibbonBannerProps>) {
   if (!ribbon) {
      return null;
   }

   const localizedOnClick = trackRibbonBannerLinkClick(ribbon);

   // Mimic Store banner placement within the hero image
   const carpenterBannerStyles = {
      position: { lg: 'absolute' },
      top: { lg: '0' },
      zIndex: { lg: '1' },
      width: '100%',
   };

   return (
      <Box
         as="section"
         bg="blue.500"
         color="white"
         p={4}
         textAlign="center"
         className="piwikTrackContent"
         sx={carpenterBannerStyles}
      >
         <PrerenderedHTML
            color="white"
            onClick={localizedOnClick}
            sx={{
               p: { marginY: 0 },
               strong: { color: 'inherit' },
               a: { color: 'inherit', textDecoration: 'underline' },
            }}
            html={ribbon.displayText}
         />
      </Box>
   );
}

function trackRibbonBannerLinkClick(ribbon: RibbonBannerData): MouseEventHandler {
   return event => {
      const element = event.target;
      if (element instanceof HTMLAnchorElement && element.href) {
         trackCustomEvent({
            eventCategory: 'Ribbon Banner',
            eventAction: `${ribbon.title} - Link - Clicked`,
            eventName: 'Homepage',
         });
      }
   };
}
